import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Competencia } from './competencia.model';
import {ConsultaPaginada, ConsultaPaginadaResultado} from 'maestro-ng';
import {BaseService} from '../services/base-service.service';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class CompetenciaService extends BaseService<Competencia, number> {

  constructor(http: HttpClient) {
    super('competencia', http);
  }

  public recuperarPorId(id: number): Promise<Competencia> {
    return firstValueFrom(this.http.get<Competencia>(this.path(`${id}`)));
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<Competencia>> {
    return this.service.recuperarPaginado(consulta);
  }

  public recuperarSugestoes(termo: string): Promise<Competencia[]> {
    return this.service.recuperarSugestoes(termo);
  }
}
